import React, { useState } from 'react';
import { customStyle } from '../../Components/Style';
import Select from 'react-select';
import CustomCalendar from '../../Components/CustomCalendar';
import DatePicker from 'react-datepicker';
import "../../Assets/Css/Leave.scss";
import UploadIcon from "../../Assets/Images/Leave/Upload.svg"
import { useNavigate } from 'react-router-dom';

const LeaveType = [
     { value: "Earned", label: "Earned" },
     { value: "Casual", label: "Casual" },
     { value: "Unpaid", label: "Unpaid" },
];

const statusOptions = [
     { value: "Approved", label: "Approved" },
     { value: "Rejected", label: "Rejected" },
     { value: "Pending", label: "Pending" },
];

const Employees = [
     { value: "Meet", label: "Meet" },
     { value: "Kuntesh", label: "Kuntesh" },
     { value: "Raj", label: "Raj" },
     { value: "Harsh", label: "Harsh" },
     { value: "Nand", label: "Nand" },
];

const AddEditLeave = () => {
     const [selectFilters, setSelectedFilters] = useState({
          date: "",
          status: [],
          leaveType: [],
          employee: []
     });
     const [files, setFiles] = useState([]);
     const [selectedDuration, setSelectedDuration] = useState('');
     const [joiningDate, setJoiningDate] = useState({ name: "" });
     const navigate = useNavigate()

     const handleFileChange = (event) => {
          const newFiles = Array.from(event.target.files);

          setFiles(prevFiles => [...prevFiles, ...newFiles]);
     };

     const hadleBack = () => {
          navigate('/leave')
     }

     return (
               <div className="addUpdateShareholder-main">
                    <div className="page-title">
                         <h4>Assign Leave</h4>
                         <div className="edit-btn">
                              <button
                                   type="submit"
                                   className="custom-btn"
                                   onClick={hadleBack}
                              >
                                   Cancel
                              </button>

                              <button
                                   type="submit"
                                   className="custom-btn"
                                   onClick={hadleBack}
                              >
                                   Save
                              </button>
                         </div>
                    </div>

                    <div className="content-part">
                         <div className="row">
                              <div className="col-lg-12">
                                   <div className="leave-card">
                                        <div className="custom-row">
                                             <div className="row">
                                                  {/* name */}
                                                  <div className="col-lg-4 col-md-6">
                                                       <div className="input-group">
                                                            <div className="label">Member</div>
                                                            <Select
                                                                 value={selectFilters.employee}
                                                                 onChange={(data) =>
                                                                      setSelectedFilters({ ...selectFilters, employee: data })
                                                                 }
                                                                 options={Employees}
                                                                 placeholder={"--"}
                                                                 styles={customStyle}
                                                                 theme={(theme) => ({
                                                                      ...theme,
                                                                      colors: {
                                                                           ...theme.colors,
                                                                           primary25: "#5757fe",
                                                                           primary: "#5757fe",
                                                                      },
                                                                 })}
                                                            />
                                                       </div>
                                                  </div>

                                                  {/* leave type */}
                                                  <div className="col-lg-4 col-md-6">
                                                       <div className="input-group">
                                                            <div className="label">Leave Type</div>
                                                            <Select
                                                                 value={selectFilters.leaveType}
                                                                 onChange={(data) =>
                                                                      setSelectedFilters({ ...selectFilters, leaveType: data })
                                                                 }
                                                                 options={LeaveType}
                                                                 placeholder={"--"}
                                                                 styles={customStyle}
                                                                 theme={(theme) => ({
                                                                      ...theme,
                                                                      colors: {
                                                                           ...theme.colors,
                                                                           primary25: "#5757fe",
                                                                           primary: "#5757fe",
                                                                      },
                                                                 })}
                                                            />
                                                       </div>
                                                  </div>

                                                  {/* status */}
                                                  <div className="col-lg-4 col-md-6">
                                                       <div className="input-group">
                                                            <div className="label">Status</div>
                                                            <Select
                                                                 value={selectFilters.status}
                                                                 onChange={(data) =>
                                                                      setSelectedFilters({ ...selectFilters, status: data })
                                                                 }
                                                                 options={statusOptions}
                                                                 placeholder={"--"}
                                                                 styles={customStyle}
                                                                 theme={(theme) => ({
                                                                      ...theme,
                                                                      colors: {
                                                                           ...theme.colors,
                                                                           primary25: "#5757fe",
                                                                           primary: "#5757fe",
                                                                      },
                                                                 })}
                                                            />
                                                       </div>
                                                  </div>

                                                  {/* duration */}
                                                  <div className="col-lg-4 col-md-6">
                                                       <div className="input-group">
                                                            <div className="label">Select Duration</div>
                                                            <div className="col-lg-12 label duration">
                                                                 <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                                                                      <div className="input-group">
                                                                           <div className="form-check">
                                                                                <input
                                                                                     className="form-check-input"
                                                                                     type="radio"
                                                                                     name="duration"
                                                                                     id="single"
                                                                                     value="single"
                                                                                     checked={selectedDuration === "single"}
                                                                                     onChange={(e) => setSelectedDuration(e.target.value)}
                                                                                />
                                                                                <label className="label" htmlFor="single">
                                                                                     Single
                                                                                </label>
                                                                           </div>
                                                                      </div>
                                                                 </div>
                                                                 <div className="col-xl-3 col-lg-6 col-md-6  col-sm-6">
                                                                      <div className="input-group">
                                                                           <div className="form-check">
                                                                                <input
                                                                                     className="form-check-input"
                                                                                     type="radio"
                                                                                     name="duration"
                                                                                     id="multiple"
                                                                                     value="multiple"
                                                                                     checked={selectedDuration === "multiple"}
                                                                                     onChange={(e) => setSelectedDuration(e.target.value)}
                                                                                />
                                                                                <label className="form-check-label" htmlFor="multiple">
                                                                                     Multiple
                                                                                </label>
                                                                           </div>
                                                                      </div>
                                                                 </div>
                                                                 <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                                                                      <div className="input-group">
                                                                           <div className="form-check">
                                                                                <input
                                                                                     className="form-check-input"
                                                                                     type="radio"
                                                                                     name="duration"
                                                                                     id="firstHalf"
                                                                                     value="firstHalf"
                                                                                     checked={selectedDuration === "firstHalf"}
                                                                                     onChange={(e) => setSelectedDuration(e.target.value)}
                                                                                />
                                                                                <label className="form-check-label" htmlFor="firstHalf">
                                                                                     First Half
                                                                                </label>
                                                                           </div>
                                                                      </div>
                                                                 </div>
                                                                 <div className="col-xl-3 col-lg-6 col-md-6  col-sm-6">
                                                                      <div className="input-group">
                                                                           <div className="form-check">
                                                                                <input
                                                                                     className="form-check-input"
                                                                                     type="radio"
                                                                                     name="duration"
                                                                                     id="seconfhalf"
                                                                                     value="seconfhalf"
                                                                                     checked={selectedDuration === "seconfhalf"}
                                                                                     onChange={(e) => setSelectedDuration(e.target.value)}
                                                                                />
                                                                                <label className="form-check-label" htmlFor="seconfhalf">
                                                                                     Second Half
                                                                                </label>
                                                                           </div>
                                                                      </div>
                                                                 </div>

                                                            </div>
                                                       </div>
                                                  </div>

                                                  <div className="col-lg-4 col-md-6">
                                                       <div className="input-group">
                                                            <div className="label">Date</div>
                                                            {selectedDuration === "multiple" ? (
                                                                 <CustomCalendar />
                                                            ) : (
                                                                 <DatePicker
                                                                      styles={customStyle}
                                                                      selected={joiningDate.name ? new Date(joiningDate.name) : null}
                                                                      onChange={(date) => {
                                                                           setJoiningDate((preVal) => ({
                                                                                ...preVal,
                                                                                name: date.toISOString().split('T')[0],
                                                                           }));
                                                                      }}
                                                                      dateFormat="dd-MM-yyyy"
                                                                      name="transaction_date"
                                                                      placeholderText="Date"
                                                                 />
                                                            )}
                                                       </div>
                                                  </div>

                                                  <div className="col-lg-12 col-md-12">
                                                       <div className="input-group">
                                                            <div className="label">Reason</div>
                                                            <textarea rows="4" cols="50" className="form-control" style={{ width: "100%" }} name="reason" placeholder="e.g. Feeling not well." />
                                                       </div>
                                                  </div>

                                                  <div className="col-lg-12 col-md-12">
                                                       <div className="input-group">
                                                            <label className="label">Document</label>
                                                            <div className="file-upload-wrapper">
                                                                 <label htmlFor="file-upload" className="file-upload-label">
                                                                      <img src={UploadIcon} alt="" />
                                                                      <p>Select files</p>
                                                                 </label>
                                                                 <input
                                                                      type="file"
                                                                      id="file-upload"
                                                                      className="file-upload-input"
                                                                      name="photos"
                                                                      multiple
                                                                      onChange={handleFileChange}
                                                                 />
                                                            </div>
                                                       </div>
                                                  </div>
                                             </div>
                                        </div>

                                   </div>
                              </div>
                         </div>
                    </div>
               </div>

     );
};

export default AddEditLeave;
